<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <nav>
        <ul>
          <li class="nav-item">
            <router-link class="nav-item" tag="a" to="/imprint">
                Imprint
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-item" tag="a" to="/privacy">
                Privacy
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-item" tag="a" to="/conditions">
                Conditions
            </router-link>
          </li>
          <li class="nav-item">
              <router-link class="nav-item" tag="a" to="/documentation">
                Docu
            </router-link>
          </li>
        </ul>
      </nav>
      <div>
        <div class="copyright">
          © {{ year }}, made with <i class="fa fa-heart heart"></i> by <a
            href="https://vuejs.org"
            class="font-weight-bold ml-1"
            target="_blank"
            rel="noopener"
            >VUE JS</a
          >, 
          <a
            href="https://vuetifyjs.com/"
            class="font-weight-bold ml-1"
            target="_blank"
            rel="noopener"
            >VUETIFY JS</a
          >
          and<a
            href="https://laravel.com"
            class="font-weight-bold ml-1"
            target="_blank"
            rel="noopener"
            >Laravel</a
          >
          for a better web.
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style></style>
